var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullMasterTemplate',{attrs:{"useLeft":false}},[_c('div',{staticClass:"full-content",attrs:{"id":"inner-wrap"}},[(_vm.isEnablePopupNotice)?_c('PopupNotioce',{attrs:{"comCode":_vm.current.company.comCode}}):_vm._e(),_c('FixedWebpartContainer'),_c('WebpartContainer',{attrs:{"templateName":`Home`}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }